// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.spotlight.RentalManagerUserPropertySpotlightWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  GetSpotlightedListingsResponseDto,
  GetUserPropertySpotlightOverviewResponseDto,
  ListingAlias,
} from '../..';

interface ApplyParams {
  listingAlias: ListingAlias;
}
interface ReassignParams {
  fromListingAlias: ListingAlias;
  toListingAlias: ListingAlias;
}
interface RemoveParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertySpotlightWebApiHandler_apply_Path =
  '/api/web/v1/users/properties/spotlight/apply';

/**
 * Apply listing spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_apply = (
  getParams: ApplyParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ApplyParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySpotlightWebApiHandler_apply_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySpotlightWebApiHandler_list_Path = '/api/web/v1/users/properties/spotlight/list';

/**
 * Get listings with spotlight promotion
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_list = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, GetSpotlightedListingsResponseDto>({
    endpoint: RentalManagerUserPropertySpotlightWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySpotlightWebApiHandler_overview_Path =
  '/api/web/v1/users/properties/spotlight/overview';

/**
 * Get spotlight overview for user properties
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_overview = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, GetUserPropertySpotlightOverviewResponseDto>({
    endpoint: RentalManagerUserPropertySpotlightWebApiHandler_overview_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySpotlightWebApiHandler_reassign_Path =
  '/api/web/v1/users/properties/spotlight/reassign';

/**
 * Reassign listing spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_reassign = (
  getParams: ReassignParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ReassignParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySpotlightWebApiHandler_reassign_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertySpotlightWebApiHandler_remove_Path =
  '/api/web/v1/users/properties/spotlight/remove';

/**
 * Remove listing spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_remove = (
  getParams: RemoveParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<RemoveParams, never, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertySpotlightWebApiHandler_remove_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};
